import React, { useState } from "react"
import { useStaticQuery, graphql } from "gatsby";
import { Link } from "gatsby"
import { Container, Row, Col, Form } from "react-bootstrap"
import ScrollAnimation from 'react-animate-on-scroll';
// import Img from 'gatsby-image';
import { GatsbyImage, getImage } from "gatsby-plugin-image"
import parse from 'html-react-parser';
import GenerateLink from "../../common/site/generate-link"
import VirtualTourPlay from "../../Play/CustomVideoFullImageClick"

import ContactModal from "../../ModalForm/Contact"
import "./About.scss"

import { inViewOptions, containerVariants, contentItem, fadeInFromTop, titleVariants, contentVariants } from '../../utils/animation';

import { motion } from "framer-motion";
import { InView } from "react-intersection-observer";

const BranchAbout = (props) => {
    const [isPlay, setPlay] = useState(false);
    
    const data = useStaticQuery(graphql`
    query {
      glstrapi {
        officeDetailsModule {
            Market_your_property_CTA_Label
            Market_your_property_Content
            Market_your_property_Video_URL
            News_Section_Intro
            Footer_Help_Module {
              CTA_1_Label
              CTA_2_Label
              Content
              Name
              Show_Chart
              CTA_1_Link {
                id
              }
              CTA_2_Link {
                id
              }
              Select_Form {
                Select
              }
            }
            Market_your_property_CTA_Link {
              id
            }
            Select_Help_Module_to_Show {
              CTA_1_Label
              CTA_2_Label
              CTA_1_Link {
                id
              }
              CTA_2_Link {
                id
              }
              Content
              Name
              Show_Chart
              Select_Form {
                Select
              }
            }
            Services_Links {
              Services_Background_Title
              Add_Service_Tile {
                Title
                Link {
                  id
                }
                Tile_Background_Image {
                  url
                  alternativeText 
                }
              }
            }
            Market_your_property_Image {
              url
              alternativeText
              url_sharp {
                childImageSharp {
                  gatsbyImageData(
                    formats: [AUTO,WEBP]
                    width: 700
                    quality: 90
                    layout: CONSTRAINED
                    transformOptions: { cropFocus: CENTER, fit: COVER }
                  )
                }
              } 
            }
            About_Wards_CTA_Label
            About_Wards_CTA_Link {
              id
            }
          }
  
      }
    }
    `);
  

    const module = data.glstrapi.officeDetailsModule;
    return (
        <InView  {...inViewOptions}>
            {({ ref, inView }) => (
                <motion.section
                    className={`about-section components--Home--About--About ${module.Market_your_property_Image ? 'with-image' : 'without-image'}`}
                    ref={ref}
                    initial="visible"
                    animate={"visible"}
                    variants={containerVariants}

                >
                    <Container>
                        {module.Market_your_property_Image ?
                            <Row className="main-row-align">
                                {module.Market_your_property_Image && !props.Image &&
                                    <Col md="12" lg="6" xl="7">
                                        <motion.div variants={titleVariants} className={`image-video ${props.Intro_Video_URL ? 'img-cursor' : ''}`}>

                                            {props.Intro_Video_URL ?
                                            <VirtualTourPlay url={props.Intro_Video_URL}>
                                                <GatsbyImage image={getImage(module.Market_your_property_Image.url_sharp)} alt={module.Market_your_property_Image.alternativeText} /> 
                                            </VirtualTourPlay>
                                            :
                                            <GatsbyImage image={getImage(module.Market_your_property_Image.url_sharp)} alt={module.Market_your_property_Image.alternativeText} /> 
                                            } 
                                        </motion.div>
                                    </Col>
                                }
                                {module.Market_your_property_Image && props.Image &&
                                    <Col md="12" lg="6" xl="7">
                                        <motion.div variants={titleVariants} className={`image-video`}>
                                         <img src={props.Image} /> 
                                        </motion.div>
                                    </Col>
                                }
                                <Col md="12" lg="6" xl="5">
                                    <motion.div variants={contentVariants} className="about-content">
                                        {props.Intro_Title &&
                                            <h4 className="sub-title">{props.Intro_Title}</h4>
                                        }
                                        {module.Market_your_property_Content &&
                                            <div className="main-content">
                                                {parse(module.Market_your_property_Content)}
                                            </div>
                                        }

                                        {module.Market_your_property_CTA_Label && module.Market_your_property_CTA_Link &&
                                            <GenerateLink link={module.Market_your_property_CTA_Link} class="btn">
                                                <span>{module.Market_your_property_CTA_Label}</span>
                                                <i className="icon-arrow"></i>
                                            </GenerateLink>
                                        }
                                        {module.Market_your_property_CTA_Label && module.Intro_CTA_Form === "Contact_Form" &&
                                            <ContactModal class="btn"> {module.Market_your_property_CTA_Label}<i className="icon-arrow"></i></ContactModal>
                                        }

                                    </motion.div>
                                </Col>
                            </Row>
                            :
                            <Row>
                                <Col md="12">
                                    <motion.div variants={titleVariants} className="about-block-title">
                                        {props.Intro_Title &&
                                            <span className="sub-title">{props.Intro_Title}</span>
                                        }

                                        {props.Intro_Heading &&
                                            <>
                                                {parse(props.Intro_Heading)}
                                            </>
                                        }
                                    </motion.div>
                                </Col>
                                <Col md="12" className="d-lg-flex justify-content-end">
                                    <motion.div variants={contentVariants} className="about-block">
                                        {props.Intro_Content &&
                                            <div className="main-content">
                                                {parse(props.Intro_Content)}
                                            </div>
                                        }

                                        {props.Intro_CTA_Label && props.Intro_CTA_Link &&
                                            <GenerateLink link={props.Intro_CTA_Link} class="btn btn-about-link"><span>{props.Intro_CTA_Label}</span> <i className="icon-arrow"></i></GenerateLink>
                                        }
                                    </motion.div>
                                </Col>
                            </Row>
                        }
                    </Container>
                </motion.section>
            )}
        </InView>

    )
}
export default BranchAbout
